import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import BootstrapVue3 from 'bootstrap-vue-3';
// import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

import Maska from 'maska'
import {i18n} from "./i18n.js"

import VueHighlightJS from 'vue3-highlightjs';
import 'highlight.js/styles/a11y-dark.css';
import UploadFileD from './components/core/uploadFile/UploadFileD.vue';
import ConfirmAlert from './components/global/confirmAlert.js';

import PaginationD from './components/controls/PaginationComponent/PaginationD.component.vue';
import TableWithPagination from './components/controls/TableWithPagination.vue';
import table from "./components/controls/TableB.vue";
import Date from './components/controls/DatePickerSelectComponent/DatePickerSelect.component.vue';
// import { initFirebaseBackend } from './authUtils'
// import { configureFakeBackend } from './helpers/fake-backend';

// const firebaseConfig = {
//   apiKey: process.env.VUE_APP_APIKEY,
//   authDomain: process.env.VUE_APP_AUTHDOMAIN,
//   databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//   projectId: process.env.VUE_APP_PROJECTId,
//   storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
//   appId: process.env.VUE_APP_APPId,
//   measurementId: process.env.VUE_APP_MEASUREMENTID
// };

// if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
//   initFirebaseBackend(firebaseConfig);
// } else {
//   configureFakeBackend();
// }

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import {Tabs, Tab} from 'vue3-tabs-component';

import store from "./state/store";

import "../src/design/app.scss";

const app = createApp(App);

app.config.globalProperties.$confirm = ConfirmAlert;
app.component("upload-file-d", UploadFileD);
app.component("pagination-d-component", PaginationD);
app.component("table-pagination", TableWithPagination);
app.component('table-b', table);
app.component('tabs', Tabs);
app.component('tab', Tab);
app.component('datepicker-select-d', Date);
app.use(store);
app.use(router);
app.use(require('vue-chartist'));
app.use(BootstrapVue3);
// app.use(VueApexCharts);
app.use(vClickOutside);
app.use(i18n);
app.use(registerScrollSpy);
app.use(Maska);
app.use(VueHighlightJS);
app.mount('#app');

// createApp(App)
//   .component("upload-file-d", UploadFileD)
//   .use(store)
//   .use(router)
//   .use(require('vue-chartist'))
//   .use(BootstrapVue3)
//   .use(VueApexCharts)
//   .use(vClickOutside)
//   .use(i18n)
//   .use(registerScrollSpy)
//   .use(Maska)
//   .use(VueHighlightJS)
//   .mount('#app')